/**
 * The "Need inspiration?" catalogue — LC_user_flow_05Sep2026, slide 4.
 *
 * A static file, not an API. Ian confirmed on 9 Sep that the categories and
 * idea cards are "fixed for now", so there is nothing for a server to serve and
 * nothing for anyone to edit without a deploy. If that changes, this shape is
 * what an endpoint would return.
 *
 * ── Audiences ───────────────────────────────────────────────────────────────
 * The seven codes are NOT decoration: they are the same T1–T7 tiers the AI
 * engine collects (see TIERS in the API's services/dq_ai/constants.dq_ai.js),
 * in the same order and with the same age ranges. Sending a matching code lets
 * the assistant treat the audience step as answered instead of asking again.
 * The code itself is internal and never shown — the label and ages are.
 */

export const AUDIENCES = [
    { code: 'T1', label: 'Lower Primary',  ages: '7-9' },
    { code: 'T2', label: 'Upper Primary',  ages: '10-12' },
    { code: 'T3', label: 'Middle School',  ages: '13-14' },
    { code: 'T4', label: 'High School',    ages: '15-17' },
    { code: 'T5', label: 'Tertiary',       ages: '18-22' },
    { code: 'T6', label: 'General Public', ages: 'all ages' },
    { code: 'T7', label: 'Workforce',      ages: '25-64' },
];

/**
 * What a person might build. Numbered 01–04 because the deck numbers them, and
 * because the order is the reading order of the row — not a sequence anyone
 * moves through.
 */
export const BUILD_CATEGORIES = [
    { id: 'online_safety',    n: '01', label: 'Online safety' },
    { id: 'digital_literacy', n: '02', label: 'AI & digital literacy' },
    { id: 'ai_ethics',        n: '03', label: 'AI ethics' },
    { id: 'ai_skills_work',   n: '04', label: 'AI skills for work' },
];

/**
 * Idea cards. Clicking one fills the prompt box with `prompt` — that sentence
 * is what the person would have typed, so it must read as their words, not as
 * a category name.
 *
 * `category` ties a card to the row above so picking a category can filter to
 * its ideas; `meta` is the caption the deck prints under each card.
 */
export const IDEA_CARDS = [
    {
        category: 'online_safety',
        prompt: 'Help my learners recognize cyberbullying and respond to it safely.',
        meta: 'Online safety · Ages 9-12',
        audience: 'T2',
    },
    {
        category: 'digital_literacy',
        prompt: 'Teach my learners how generative AI works.',
        meta: 'AI & digital literacy · Ages 13-17',
        audience: 'T4',
    },
    {
        category: 'ai_ethics',
        prompt: 'Help my students identify bias and make responsible decisions when using AI.',
        meta: 'AI ethics · Higher education',
        audience: 'T5',
    },
    {
        category: 'ai_skills_work',
        prompt: 'Train my team to write effective, secure prompts for everyday work tasks.',
        meta: 'AI skills for work · Workplace',
        audience: 'T7',
    },
];

/**
 * The frameworks named on slide 4.
 *
 * A short, ordered list of the ones a reader recognises — deliberately not the
 * full catalogue the engine can align to, which runs past a hundred. The last
 * entry is the honest catch-all for everything not named here.
 */
export const NAMED_FRAMEWORKS = [
    { n: '01', label: 'DQ Global Standards — IEEE 3527.1' },
    { n: '02', label: 'UNESCO AI Competency Framework' },
    { n: '03', label: 'OECD AI Literacy Framework' },
    { n: '04', label: 'DigComp 3.0' },
    { n: '05', label: 'Relevant national or sector frameworks' },
];
